import { render, staticRenderFns } from "./BandejaDoctorLinkPacientePTIPresuntivoComponente.vue?vue&type=template&id=ac1ce28a"
import script from "./BandejaDoctorLinkPacientePTIPresuntivoComponente.vue?vue&type=script&lang=js"
export * from "./BandejaDoctorLinkPacientePTIPresuntivoComponente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports